<template>
  <div class="userinfos">
    <div class="userImgBox">
      <ul>
        <li>头像</li>
        <li><img
            :src="PhotoImage"
            :onerror="defaultImg"
            alt=""
          ></li>
      </ul>
    </div>
    <div>
      <mt-cell
        title="姓名"
        :value="StuName"
      ></mt-cell>
      <mt-cell
        title="电话"
        :value="Phone"
      ></mt-cell>
      <!-- <mt-cell
        title="行业"
        :value="ProfessionName"
      ></mt-cell> -->
      <mt-cell
        title="身份证号"
        :value="IdCard"
      ></mt-cell>
      <!-- <mt-cell
        title="从业资格证"
        :value="Certificate"
      ></mt-cell> -->
      <mt-cell
        title="在册状态"
        :value="register==='1'?'在册':'不在册'"
      ></mt-cell>

      <!-- <mt-cell
        title="所属公司"
        :value="CompanyName"
      ></mt-cell> -->
      <mt-cell
        title="人员类型"
        value="驾驶员"
      ></mt-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userinfos',
  data () {
    return {
      PhotoImage: sessionStorage.getItem('photo'),
      StuName: sessionStorage.getItem('userName'),
      Phone: sessionStorage.getItem('phone'),
      ProfessionName: sessionStorage.getItem('professionName'),
      IdCard: sessionStorage.getItem('IdCard'),
      Certificate: sessionStorage.getItem('CertificateNo'),
      register: sessionStorage.getItem('register'),
      CompanyName: sessionStorage.getItem('companyName'),
      userinfo: {},
      defaultImg:
        'this.src="' + require('../assets/imgs/defaultUCpic.png') + '"' // 默认图地址
    }
  },
  created () {
    var userId = sessionStorage.getItem('userId')
    if (userId === '' || userId === null || userId === undefined) {
      this.$router.push({
        path: '/'
      })
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/Userinfo.vue